// Chinese (mandarin)

export default {

  component: {
    jobAdList: {
      title: '空缺工作职位',
      jobs: '工作',
      noJobAds: '当前没有空缺工作职位。',
    },

    jobAdCard: {
      openUntil: date => `开放截止时间：${date}`,
    },

    jobAdGreetings: {
      thankYou: '谢谢！',
      readyInfo: '您的申请已收到，招聘人员会尽快与您联系。',
      luck: '祝您好运！',
    },

    jobAdSeeYou: {
      title: '谢谢！',
      description: '您的申请已保存，我们已向您的邮箱发送您的申请链接，稍候请点击申请链接继续您的申请。',
    },

    unpublished: {
      title: '未发布',
      info: '此招聘广告尚未发布。',
    },
  },

  page: {},

}
